export const COURTESY_PRODUCT_OPTIONS = [
  { label: "Jusfy - Internos", value: "jusfy_internal", sortPriority: 1 },
  { label: "Jusfy - Clientes", value: "jusfy_customers", sortPriority: 2 },
  { label: "Parceiros e Fornecedores", value: "partners", sortPriority: 3 },
  { label: "OAB", value: "oab", sortPriority: 4 }
].sort((a, b) => a.sortPriority - b.sortPriority);

export const COURTESY_DURATION_TYPES = [
  { label: "Meses", value: "activeMonths" },
  { label: "Dias", value: "activeDays" }
];

// Intervalos aceitos pelo serviço de recorrência que integra com o JusSub.
export const COURTESY_JUSSUB_ALLOWED_DAYS = [1, 7, 14, 30, 60, 90, 180, 365];

const COURTESY_JUSSUB_DAYS_LABELS = {
  1: "1 dia",
  7: "7 dias (1 semana)",
  14: "14 dias (2 semanas)",
  30: "30 dias (1 mês)",
  60: "60 dias (2 meses)",
  90: "90 dias (3 meses)",
  180: "180 dias (6 meses)",
  365: "365 dias (1 ano)"
};

export const COURTESY_JUSSUB_DURATION_OPTIONS = COURTESY_JUSSUB_ALLOWED_DAYS.map(
  days => ({
    label: COURTESY_JUSSUB_DAYS_LABELS[days],
    value: days
  })
);

// A api espera o enum de recorrência do JusSub, não a quantidade de dias.
const COURTESY_JUSSUB_INTERVAL_BY_DAYS = {
  1: "DAILY",
  7: "WEEKLY",
  14: "BIWEEKLY",
  30: "MONTHLY",
  60: "BIMONTHLY",
  90: "QUARTERLY",
  180: "SEMIANNUALLY",
  365: "ANNUALLY"
};

export const toCourtesyJusSubInterval = days =>
  days != null ? COURTESY_JUSSUB_INTERVAL_BY_DAYS[days] : undefined;
